import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    gridShopMain: {
      [theme.breakpoints.down(335)]: {
        justifyContent: 'center!important',
        marginLeft: '0px!important',
      },
      justifyContent: 'left!important',
      alignItems: 'center!important',
      marginLeft: '20px!important',
      display: 'block!important',
      width: 'auto!important',
    },
    gridAboutMain: {
      padding: '5px 0',
      borderBottom: '1px solid #efefef',
      width: '100%!important',
      borderRadius: 10,
      margin: '2px 0px 0px!important',
    },
    gridAbout: {
      alignItems: 'center',
    },
    textAbout: {
      margin: '0px!important',
      fontSize: 13,
      marginLeft: '5px!important',
      color: '#35383d',
    },
    titleShop: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.01em',
      },
      margin: '0px!important',
      color: '#33373c',
      fontSize: '1.11em',
      width: '100%',
    },
    textShop: {
      color: '#929292',
      fontSize: 12,
      margin: '0px!important',
    },
    bannerShopMain: {
      width: 72,
      height: 72,
      borderRadius: 10,
      objectFit: 'cover',
    },
    gridDescription: {
      [theme.breakpoints.down(700)]: {
        width: '75%',
      },
      [theme.breakpoints.down(430)]: {
        width: '72%',
      },
      [theme.breakpoints.down(392)]: {
        width: '70%',
      },
      [theme.breakpoints.down(560)]: {
        width: '65%',
      },
      [theme.breakpoints.down(307)]: {
        width: '100%',
        marginLeft: '0px!important',
        textAlign: 'center!important',
      },
      width: '80%',
      marginLeft: '10px!important',
    },
    gridDescriptionsMain: {
      display: 'block',
    },
    textBtn: {
      [theme.breakpoints.down(370)]: {
        fontSize: 12,
      },
      [theme.breakpoints.down(350)]: {
        fontSize: 11,
      },
      [theme.breakpoints.down(330)]: {
        fontSize: 10,
      },
      fontSize: 13,
      margin: '0px!important',
      textTransform: 'none',
      color: '#4c4f53',
    },
    iconHome: {
      width: 20,
      height: 20,
      marginRight: 10,
    },
    iconProduct: {
      width: 20,
      marginRight: 10,
      height: 20,
    },
    iconInfos: {
      width: 20,
      marginRight: 10,
      height: 20,
    },
    textTagLive: {
      margin: '0px 0 5px 0!important',
      backgroundColor: '#298000',
      borderRadius: 5,
      padding: '0px 10px',
      color: '#fff',
      alignItems: 'center',
      textTransform: 'uppercase',
      fontWeight: 550,
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: 12,
    },
  }),
);

export default useStyles;
